import React from 'react';
import './services.css';
import { Helmet } from "react-helmet";

import whatsapp from '../../Assets/whatsapp.png';
import call from '../../Assets/call.png';
import DoubleNosePiercingImage from '../../Assets/Piercing Services/double nose piercing.png';
import Footer from '../contactus/contactus';

const handleWhatsAppClick = (message) => {
  const url = `https://wa.me/971567257579?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank");
};

function DoubleNosePiercing() {
  return (
    <div>
      <div className="earlobe-container">
        <Helmet>
            <title>Double Nose Piercing Dubai, UAE </title>
            <meta
                name="description"
                content="Double Nose Piercing Dubai, UAE for a unique and balanced look with precise placement and professional piercing care."
            />  
        </Helmet>

        <div className="floating-buttons">
          <div
            className='whatsapp-button'
            onClick={() => handleWhatsAppClick("I am interested in Double Nose Piercing")}
          >
            <img src={whatsapp} alt="WhatsApp" />
          </div>

          <a href="tel:+971567257579" className="call-button">
            <img src={call} alt="Call" />
          </a>
        </div>

        <h1 className="earlobe-title">
          Double Nose Piercing 250 AED
        </h1>

        <div className="earlobe-image-wrapper">
          <img src={DoubleNosePiercingImage} alt="Double Nose Piercing" />
        </div>

        <div className="earlobe-content">
          <h3>Double Nose Piercing</h3>

          <p>
            Make a bold and stylish statement with our professional double nose piercing services in the UAE, available at an affordable price of 250 AED. Double nose piercing is a modern and eye-catching trend that involves placing two piercings on the nose, creating a unique and striking visual appeal. Whether you prefer a symmetrical look on the same side or a balanced style on both sides, this piercing option is perfect for individuals who want to stand out and express their personality with confidence.
          </p>

          <p>
            Our expert specialists are highly trained in advanced piercing techniques, ensuring precise placement that enhances your facial features and overall aesthetic. We take the time to understand your preferences and guide you in choosing the ideal positioning and jewelry style to achieve the look you desire. Whether you opt for subtle studs, elegant hoops, or a mix of both, double nose piercing offers versatility and creativity, allowing you to customize your appearance to match your style.
          </p>

          <p>
            Safety and hygiene are our top priorities, and we strictly follow professional standards to provide a clean and secure environment for every client. We use sterile, single-use, high-quality equipment for each procedure, minimizing the risk of infection and ensuring a smooth and comfortable experience. Our certified professionals perform each double nose piercing with care and precision, using techniques designed to reduce discomfort and promote faster healing.
          </p>

          <p>
            Double nose piercing is suitable for those who want to elevate their look beyond a traditional single piercing. It adds depth and dimension to your style, making it a popular choice among fashion-forward individuals. Despite its bold appearance, the procedure is quick and typically completed within minutes, making it a convenient option for those with busy lifestyles. Our specialists ensure that the entire process is efficient, gentle, and stress-free.
          </p>

          <p>
            We also provide high-quality, hypoallergenic starter jewelry that is safe for sensitive skin, helping to prevent irritation and allergic reactions. Choosing the right jewelry is essential for both comfort and style, and our team will assist you in selecting pieces that complement your look while supporting the healing process. Our clean and welcoming environment ensures that you feel relaxed and confident throughout your visit.
          </p>

          <p>
            Aftercare is a crucial part of maintaining your double nose piercing, and we offer detailed guidance to help you care for it properly. Our team will explain the best cleaning practices, recommended products, and precautions to avoid infection or irritation. With proper aftercare, your piercing will heal smoothly and remain a long-lasting feature of your style.
          </p>

          <p>
            Our double nose piercing services in the UAE combine affordability with premium quality, offering transparent pricing with no hidden costs. Booking your appointment is simple and convenient, allowing you to choose a time that suits your schedule. We aim to provide minimal waiting time and a seamless experience from consultation to completion.
          </p>

          <p>
            Choose our trusted double nose piercing services in the UAE for a safe, hygienic, and professional experience. With skilled specialists, precise techniques, and a focus on customer satisfaction, we help you achieve a bold and fashionable look effortlessly. Book your double nose piercing appointment today and create a striking style statement with confidence.
          </p>

          <button
            className="book-btn"
            onClick={() => handleWhatsAppClick("I want to book Double Nose Piercing")}
          >
            Book Now
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default DoubleNosePiercing;